// const baseUrl = "http://localhost:8000/api";
const baseUrl = "https://examnp.herokuapp.com/api";
export default baseUrl;
